module.exports = __webpack_public_path__ + "images/icons/icon-eye-7882efc0.svg";